module.exports = __webpack_public_path__ + "static/media/ic_stu_white.644ef701.svg";